import { FunctionComponent } from "react";

/**
 * Blocking overlay shown over the center pane while leads are bulk-selected:
 * sequence editing is disabled until the selection is cleared. Shared by the
 * Inbox and Outbox (identical markup lived inline in both pages).
 */
export const SelectedLeadsOverlay: FunctionComponent = () => (
	<div className="absolute top-0 left-0 h-full w-full text-center bg-white/50 z-50">
		<div className="text-center absolute top-1/2 text-text-disabled left-1/2 -translate-x-1/2 -translate-y-1/2">
			you can not edit the sequence when you have selected leads. <br />
			<span className="font-bold">Unsaved changes will be lost.</span>
		</div>
	</div>
);
